import { Box, ContentBlock, Heading, Stack } from 'braid-design-system';
import React, { type ReactNode } from 'react';

const PageIntro = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <ContentBlock>
    <Box
      paddingTop={['xlarge', 'xxlarge']}
      paddingX={['gutter', 'xxlarge']}
      paddingBottom="medium"
      maxWidth="medium"
    >
      <Box paddingX={['none', 'large']}>
        <Stack space="large" align="center">
          <Box paddingX={['medium', 'large']}>
            <Heading level="1" align="center">
              {title}
            </Heading>
          </Box>
          <Box style={{ textWrap: 'balance' }} maxWidth="small">
            {children}
          </Box>
        </Stack>
      </Box>
    </Box>
  </ContentBlock>
);

export default PageIntro;
